import { render, staticRenderFns } from "./StudyRecords.vue?vue&type=template&id=1f75e9dc&scoped=true"
import script from "./StudyRecords.vue?vue&type=script&lang=js"
export * from "./StudyRecords.vue?vue&type=script&lang=js"
import style0 from "./StudyRecords.vue?vue&type=style&index=0&id=1f75e9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75e9dc",
  null
  
)

export default component.exports